import React from "react";
import { makeStyles } from "@material-ui/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Badge from "@material-ui/core/Badge";

const useStyles = makeStyles({
  heading: {
    fontSize: "15px",
  },
  secondaryHeading: {
    fontSize: "15px",
    color: "rgba(0,0,0,0.54)",
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  column: {
    flexBasis: "33.33%",
  },
  details: {
    display: "block",
  },
  badge: {
    top: "-2px",
    right: "-30px",
    backgroundColor: "rgba(0,0,0,0.4)",
  },
  badgeWarning: {
    top: "-2px",
    right: "-30px",
    backgroundColor: "rgb(216,27,96)",
  },
});

const CardSection = (props) => {
  const {
    heading,
    secondaryHeading,
    expanded,
    toggleExpanded,
    badgeContent,
    badgeWarning,
    defaultExpanded,
  } = props;
  const classes = useStyles();
  const badgeVisible = !expanded && badgeContent;

  return (
    <ExpansionPanel
      expanded={expanded}
      onChange={toggleExpanded}
      defaultExpanded={defaultExpanded}
      className={
        expanded ? `card-section__root--expanded` : `card-section__root`
      }
    >
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <div className={classes.column}>
          {badgeVisible ? (
            <Badge
              badgeContent={badgeContent}
              color="primary"
              classes={
                badgeWarning
                  ? { badge: classes.badgeWarning }
                  : { badge: classes.badge }
              }
            >
              <Typography className={classes.heading}>{heading}</Typography>
            </Badge>
          ) : (
            <Typography className={classes.heading}>{heading}</Typography>
          )}
        </div>
        <div className={classes.column}>
          <Typography className={classes.secondaryHeading}>
            {secondaryHeading}
          </Typography>
        </div>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.details}>
        {props.children}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default CardSection;
